<template>
  <v-dialog
      v-model="show"
      width="300"
  >
    <v-date-picker
      v-model="date"
      @change="selectedDate"
    >
    </v-date-picker>
  </v-dialog>
</template>
<script>
import dateUtils from '@/utils/dateUtils'
export default {
  props: ['visible'],
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  mounted () {

  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 10)
    }
  },
  methods: {

    selectedDate () {
      this.$log.info('date selected', [this.date])
      this.$log.info('formatted date', [dateUtils.formatDate(this.date)])
      this.$emit('dateSelected', dateUtils.formatDate(this.date))
      this.$emit('close')
    },
    cancelDialog () {
      this.$emit('close')
    }

  }
}
</script>
